/**
 * Dropbox Types
 *
 * TypeScript interfaces for Dropbox integration
 */

/**
 * OAuth tokens returned from Dropbox authentication
 */
export interface DropboxTokens {
  accessToken: string;
  refreshToken?: string;
  expiresAt?: number;
  accountId?: string;
  uid?: string;
}

/**
 * Dropbox file metadata from the Dropbox API
 */
export interface DropboxFile {
  id: string;
  name: string;
  pathLower: string;
  pathDisplay: string;
  isFolder: boolean;
  size?: number;
  serverModified?: string;
  clientModified?: string;
}

/**
 * Dropbox folder for navigation
 */
export interface DropboxFolder {
  id: string;
  name: string;
  pathLower: string;
  pathDisplay: string;
}

/**
 * Connection state for Dropbox integration
 */
export type DropboxConnectionState =
  | 'disconnected'
  | 'connecting'
  | 'connected'
  | 'error';

/**
 * Dropbox user account information
 */
export interface DropboxUserInfo {
  accountId: string;
  email: string;
  name: string;
  profilePhotoUrl?: string;
}
